import React from "react";
import { Theme, useTheme } from "@emotion/react";

import SectionContainer from "core/Components/SectionContainer";
import Text from "core/Components/Text";
import useBreakpoint from "core/hooks/useBreakpoint";
import { sort } from "core/includes/sort";
import { isDown } from 'theme/breakpoints';

import AddressContainer from "elements/Components/ContactUs/components/AddressContainer";
import City from "elements/Components/ContactUs/components/City";
import FormSection from "elements/Components/ContactUs/components/FormSection";
import ImageContainer from "elements/Components/ContactUs/components/ImageContainer";
import ImageSection from "elements/Components/ContactUs/components/ImageSection";
import Wrapper from "elements/Components/ContactUs/components/Wrapper";
import Description from "elements/Components/ContactUs/components/Text";
import Header from "elements/Components/ContactUs/components/Header";
import HeaderAndTextContainer from "elements/Components/ContactUs/components/HeaderAndTextContainer";

type Props = {
    data: ContactUs
};

const ContactUs: React.FC<Props> = ({ data }) => {
    const theme: Theme = useTheme();
    const { breakpoint } = useBreakpoint();

    const addresses = sort(data.addresses);

    const isImagePortrait = isDown(breakpoint, "md");
    const image = isImagePortrait ?
        data.portraitImage ?? data.landscapeImage :
        data.landscapeImage ?? data.portraitImage;

    const isFormOnTheTop = data.isFormOnTheTop;
    const isHeaderOnTheLeft = data.isHeaderOnTheLeft;
    const headerAndText = (
        <HeaderAndTextContainer>
            <Header>{data.header}</Header>
            <Description>{data.text}</Description>
        </HeaderAndTextContainer>
    );

    return (
        <SectionContainer>
            <Wrapper isFormOnTheTop={isFormOnTheTop}>
                <ImageSection isFormOnTheTop={isFormOnTheTop}>
                    {isHeaderOnTheLeft && (
                        headerAndText
                    )}
                    {!isHeaderOnTheLeft && image?.id && (
                        <ImageContainer image={image} useFocusPoint={data.useFocusPoint} />
                    )}
                    {addresses && (
                        <AddressContainer>
                            {addresses.map((item: Address, index: number) => (
                                <div key={`address-box-${index}`} className={'address-box'}>
                                    <City>{item.city}</City>
                                    <Text fontColour={theme.colours.doveGray3}>{item.address}</Text>
                                    <Text fontColour={theme.colours.doveGray3}>{item.phoneNumber}</Text>
                                </div>
                            ))}
                        </AddressContainer>
                    )}
                </ImageSection>
                <FormSection
                    data={data}
                    headerAndText={isHeaderOnTheLeft ? null : headerAndText}
                />
            </Wrapper>
        </SectionContainer>
    );
};

export default ContactUs;